module.exports = __webpack_public_path__ + "static/tabutabu-db3d71070acf567542f6c4bfd22d39ec.png";